import { z } from "zod";

export const loginSchema = z.object({
  email: z.string({ required_error: "El. paštas privalomas!" }),
  password: z.string({ required_error: "Slaptažodis privalomas!" }),
});

export type loginSchemaInputs = z.infer<typeof loginSchema>;
